import { render, staticRenderFns } from "./xuqiuManage.vue?vue&type=template&id=16887201&scoped=true&"
import script from "./xuqiuManage.vue?vue&type=script&lang=js&"
export * from "./xuqiuManage.vue?vue&type=script&lang=js&"
import style0 from "./xuqiuManage.vue?vue&type=style&index=0&id=16887201&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16887201",
  null
  
)

export default component.exports